// extracted by mini-css-extract-plugin
export default {"gamePlayClassic":"Classic_gamePlayClassic__qPSUG","mainArea":"Classic_mainArea__ApJE3","bonusLink":"Classic_bonusLink__w2KjU"};